import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { fromEvent } from 'rxjs';
import { exhaustMap, takeWhile, withLatestFrom } from 'rxjs/operators';
import { EulaService } from 'src/app/services/eula.service';
import { UserAuthService } from 'src/app/state/user-auth/user-auth.service';

@Component({
    selector: 'rdx-eula-dialog',
    standalone: true,
    styleUrls: ['./eula-dialog.component.scss'],
    templateUrl: './eula-dialog.component.html',
})
export class EulaDialogComponent implements OnInit, OnDestroy {
    eulaUrl: string;

    private isDestroyed = false;
    private userHasAcceptedEula = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private configService: ConfigService,
        @Inject(DOCUMENT) private document: Document,
        private eulaService: EulaService,
        private matDialogRef: MatDialogRef<EulaDialogComponent>,
        private router: Router,
        private routingHelpersService: RoutingHelpersService,
        private userAuthService: UserAuthService
    ) {}

    ngOnInit(): void {
        this.eulaUrl = this.routingHelpersService.combineUrl(
            this.configService.siteUrl,
            'eula/'
        );
        this.handleAcceptEula();
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
        if (!this.userHasAcceptedEula) {
            this.eulaService.declineCurrentEula();
            this.logout();
        }
    }

    logout(): void {
        this.userAuthService.logOut();
    }

    private handleAcceptEula(): void {
        const acceptButton = this.document.getElementById('acceptEULA');
        if (acceptButton) {
            fromEvent(acceptButton, 'click')
                .pipe(
                    exhaustMap(() => {
                        this.userHasAcceptedEula = true;
                        return this.eulaService.acceptCurrentEula();
                    }),
                    withLatestFrom(this.activatedRoute.queryParamMap),
                    takeWhile(() => !this.isDestroyed)
                )
                .subscribe(([, queryParams]) => {
                    this.matDialogRef.close();
                    const returnTo = queryParams.get('returnTo') || 'home';
                    void this.router.navigate([returnTo]);
                });
        }
    }
}
